<script lang="ts">
    import {onMount} from 'svelte';

    export let value: number;
    export let initial = getInitialValue(value);
    export let duration = 1000;
    export let locale = ''


    let counterResult = initial;
    const max = value;
    let step = 1;

    while (duration / ((max - initial) / step) < 2) {
        step++; // adjust step if short duration and/or small step and/or large delta
    }

    let intervalId: number;

    onMount(() => {
        intervalId = window.setInterval(() => {
            if (counterResult < max) {
                counterResult += step;
            }
            if (counterResult >= max) {
                window.clearInterval(intervalId);
                counterResult = max;
            }
        }, duration / ((max - initial) / step));
    });

    function getInitialValue(val: number): number {
        if (val <= 10) {
            return 0;
        }
        if (val <= 100) {
            return (Math.floor(val / 10) * 10) - 10;
        }
        return (Math.floor(val / 100) * 100) - 100;
    }

    function formatNumber(input: number): string {
        return input.toLocaleString(locale);
    }
</script>

<span aria-label={formatNumber(value)}>{formatNumber(counterResult)}</span>